module.exports = __webpack_public_path__ + "img/logo-pln.9d84417e.png";